import { useEffect } from 'react';
import { syncUniformReports } from './requestQueue';
export default function UniformSync({ user }) {
  useEffect(() => {
    if (!user || user.impersonating) return;
    const sync = () => { void syncUniformReports().catch(() => {}); };
    sync(); const timer = setInterval(sync, 60000); window.addEventListener('online', sync);
    return () => { clearInterval(timer); window.removeEventListener('online', sync); };
  }, [user?.id, user?._id, user?.impersonating]);
  return null;
}
